import React from "react";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const StartExperienceModal = ({ handleClose }) => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/80 backdrop-blur-sm animate-fade-in">
      <div className="w-full max-w-sm bg-gradient-to-b from-slate-950 to-black rounded-xl overflow-hidden shadow-2xl border border-red-900/20">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-full transition-all z-10"
        >
          <X size={20} />
        </button>

        <div className="bg-gradient-to-r from-red-950 via-red-800 to-red-950 p-6 text-center">
          <div className="w-16 h-16 bg-white/10 rounded-full mx-auto mb-3 flex items-center justify-center border border-white/20">
            <i
              className="pi pi-heart text-white animate-pulse-soft"
              style={{ fontSize: "28px" }}
            ></i>
          </div>
          <h2 className="text-3xl font-bold text-white mb-1">
            Ready for More?
          </h2>
          <p className="text-pink-200">
            She wants to fulfill your every fantasy...
          </p>
        </div>

        <div className="p-6">
          <div className="bg-red-950/30 backdrop-blur-sm p-4 rounded-lg mb-6 border border-red-900/20">
            <p className="text-sm italic text-center text-pink-200">
              "I'm getting so excited thinking about our private time
              together... Let me show you how good I can be."
            </p>
          </div>

          <button
            onClick={() => navigate("/sign-up")}
            className="w-full py-3 rounded-lg bg-gradient-to-r from-red-900 to-red-700 text-white font-semibold mb-4 relative overflow-hidden group animate-glow hover:shadow-lg hover:shadow-red-900/20 transition-all"
          >
            <span className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-red-400/0 via-white/20 to-red-400/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></span>
            Create Free Account
          </button>

          <p className="text-center text-sm text-pink-300">
            Already have an account?{" "}
            <span
              onClick={() => navigate("/login")}
              className="text-red-400 hover:underline cursor-pointer"
            >
              Log in
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default StartExperienceModal;
